import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { BootstrapContext } from 'rev-shared/bootstrap/BootstrapContext';
import { initLocale } from './LocaleContext';
import { monkeyPatchHttpRequest } from './HttpRequestUtil';

export function bootstrapAngularApp(angularRootModule): Promise<any> {
	if (process.env.NODE_ENV === 'production' && !BootstrapContext.debug) { // provided by webpack
		enableProdMode();
	}

	monkeyPatchHttpRequest();

	initLocale();

	return platformBrowserDynamic()
		.bootstrapModule(angularRootModule);
}
